export default "__VITE_ASSET__BRQqLDwc__"